// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Dx8d","inputWrap":"Table_inputWrap__2iwDe","col":"Table_col__3yZQz","bmiTooltip":"Table_bmiTooltip__3GvRw"};